// Discover scope only from the current authenticated profile. No cached IDs,
// aggregate credentials or route supplied by a visitor can select an account.
export async function recoverAccountAttention({ get, actorId, rejectedAccount, status, signal, current, cursor = {} }) {
  if (!current()) return null;
  const { data: profile } = await get('/api/v1/profile', { signal, timeout: 3500 });
  if (!current()) return null;
  if (profile?.id !== actorId || !Array.isArray(profile.accounts) || profile.accounts.length > 500) throw Error('Invalid authenticated profile');
  const accounts = [...new Set(profile.accounts.map(account => account?.id)
    .filter(id => Number.isSafeInteger(id) && id > 0 && (id !== rejectedAccount || status === 401)))].sort((a,b)=>a-b);
  const key = `${actorId}:${accounts.join(',')}`;
  if (cursor.key !== key) { cursor.key = key; cursor.index = 0; }
  if (!accounts.length) { cursor.index = 0; return null; }
  const start = cursor.index || 0;
  for (let offset = start; offset < Math.min(start + 16, accounts.length); offset += 1) {
    const id = accounts[offset];
    try {
      const { data } = await get(`/api/v1/accounts/${id}/attention`, { signal, timeout: 3500 });
      if (!current()) return null;
      if (data?.schema !== 1 || data.account_id !== id || data.actor_id !== actorId || !Array.isArray(data.items) || !Array.isArray(data.background_accounts)) throw Error('Invalid authoritative attention scope');
      return { accountId: id, data };
    } catch (failure) {
      if (!current()) return null;
      cursor.index = (offset + 1) % accounts.length;
      if (![403, 404].includes(failure.response?.status)) throw failure;
    }
  }
  cursor.index = Math.min(start + 16, accounts.length) % accounts.length;
  return null;
}
